import React from 'react';
import { NestedDataGrid } from '../common/nestedDataGrid/nestedDataGrid.jsx';
import { Tab, TabBar, BasicAlert, LabelGrid, SimpleDataGrid } from '../common/components.jsx';
import { fmDate, fmDateTime } from '../common/formatter.jsx';
import * as OSWidgetLib from '../common/osWidgetLib.js';
import * as secureValue from '../../lib/secureValue.js';
import './widget-style.css';
import * as _ from "lodash";
var TclListParser = require('../../lib/tcllist.js');



class SimpleTable extends React.Component {

  render() {
    var loadingStatus = this.props.loadingStatus
    var tabData = this.props.tabData;

    if (loadingStatus == 'S') {

     return (
        <table className="table table-hover">
        <thead>
          <tr>
            {tabData.header.map(( val, index ) => {
              return (
                <th>{val.name}</th>
              );
          })}
          </tr>
        </thead>
        <tbody>
        {tabData.data.map(( val2, index ) => {

          return (
            <tr key={index}>
              {val2.map(( val3, index ) => {
                return (
                  <td>{val3}</td>
                );
              })}
            </tr>
          );
        })}
        </tbody>
      </table>
     ) 
    } else {
      return  (
          <BasicAlert type={loadingStatus} />
        )
    }   

  }

}


/*----------------------------------------------------------------------------
|   NestedDataGridWrapper
|
\---------------------------------------------------------------------------*/
class NestedDataGridWrapper extends React.Component {

  formatData(dataSum, dataDtl, category) {

    if (category == "esd") {
      var fIndex = 11;
    } else if (category == "lpd"){
      var fIndex = 3;
    }

    const categoryData = {
      header: dataSum.header
    };
    const childHeader = dataDtl.header

    const groupedByPDAPI = {};
    dataSum.data.map(row => {
      const pdapi_no = row[0];
      groupedByPDAPI[pdapi_no] ? groupedByPDAPI[pdapi_no].push(row) : groupedByPDAPI[pdapi_no] = [row];
      return row;
    });

    categoryData.data = Object.keys(groupedByPDAPI).map(groupItem => {
      const currGr = groupedByPDAPI[groupItem];
      const currGrData = { data: [] };
      currGr.map(cgItem => {
        const firstRow = currGr[0];
        currGrData.parentRowData = firstRow;
        currGrData.header = childHeader;


        for (var i = 0; i < dataDtl.data.length; i++) {
          if (dataDtl.data[i][fIndex] == cgItem[0] && currGrData.data.indexOf(dataDtl.data[i]) === -1) {
            currGrData.data.push(dataDtl.data[i]);
          }
        }

        return cgItem;
      })
      return currGrData;
    })

    return categoryData;
  }

  render() {

    var categoryData = this.formatData(this.props.dataSum, this.props.dataDtl, this.props.id);

    return (
      <NestedDataGrid
        id={this.props.id}
        enableDownload={this.props.enableDownload}
        leftLabel={categoryData.data.length + " items"}
        downloadName={this.props.downloadName}
        header={categoryData.header}
        data={categoryData.data}
      />
    )
  }

}


/*----------------------------------------------------------------------------
|   ESDCommHistModal
|
\---------------------------------------------------------------------------*/
class ESDCommHistModal extends React.Component {

  handleCloseCaseModal = e => {
    this.props.onClose && this.props.onClose(e);
  };

  render() {

    var url = "/os/commhistajax.tcl?a0=getPDAPICommHistNewUI&a1="+ this.props.pdapiHash +"&a2=HPI"

    var displayCondition 
    if (!this.props.show) {
      displayCondition = "none";
    } else {
      displayCondition = "block"
    }
    
    return (
      <div className="modal" id="esdCOmmHistModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style={{"display": displayCondition}}>
        <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-hidden="true" onClick={this.handleCloseCaseModal}>x</button>
                <h3 className="modal-title" id="threeWCaseModalHeading">Email Communication Viewer</h3>
              </div>
              <div className="modal-body" style={{"height": "400px"}}>
                <div className="form-group">
                  <div className="col-sm-12">
                    <iframe src={url} style={{"width": "100%", "height": "365px"}}/>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" onClick={this.handleCloseCaseModal} className="btn btn-info">Cancel</button>
              </div>
            </div>
          </div>
      </div>
    )
  }
}




/*----------------------------------------------------------------------------
|   Services
|
\---------------------------------------------------------------------------*/
export class Services extends React.Component {

  constructor(props) {
    super(props);

    this.getDASDocIds = this.getDASDocIds.bind(this);
    this.handleEmailViewer = this.handleEmailViewer.bind(this);

    var hasPolyItems = OSWidgetLib.PolyServiceOrder(this.props.order)
    var items = this.props.order.items;

    console.log("Services constructor hasPolyItems=", hasPolyItems);

    this.state = {
      cpStatus: 'L',
      cpEmailStatus: 'L',
      serviceStatus: 'L',
      cpCommStatus: 'L',
      cpHdrStatus: 'L',
      cpErrorStatus: 'L',
      esdStatus: 'L',
      esdDtlStatus: 'L',
      lpdStatus: 'L',
      gemstoneStatus: 'L',
      otherStatus: 'L',
      hasPolyItems: hasPolyItems,
      dasStatus: 'L',
      certObjLoaded: false,
      certObjStore: {},
      carepackErrorDtaLoading: false,
      otherStatusData: {},
      carepackHdrData: {},
      carepackDtlData: {},
      carepackEmailDta: {},
      serviceDta: {},
      carepackCommDta: {},
      carepackErrorDta: { header: [],
                          data: []
                        },
      esdSumDta : {},
      esdDtlData: {},
      lpdData   : {},
      dasData   : {},
      showESDCommHist: false,
      gemstoneData: {}  
    };
  }

  componentDidMount() {
    if (this.props.caller == 'ext_widget') {
      this.getCPData(this.props.order.legacy_order_no)
      this.getCPDtlData(this.props.order)
    } else {
      this.getCPData(this.props.order.legacy_order_no)
      this.getCPDtlData(this.props.order)
      this.getCPEmails(this.props.order.legacy_order_no)
      this.getServiceValidation(this.props.order)
      this.getCPComm(this.props.order.legacy_order_no)
      this.getESDData(this.props.order.legacy_order_no)
      this.getESDDtlData(this.props.order.legacy_order_no)
      //GetPDAPI Email Link?
      this.getLpdData(this.props.order.legacy_order_no)
      this.getGemstoneData(this.props.order.legacy_order_no)
      this.getOtherData(this.props.order.legacy_order_no)  
      if (this.state.hasPolyItems) {
          this.getDASDocIds();
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.cpStatus === 'S' &&
      this.state.cpErrorStatus === 'L' &&
      !this.state.carepackErrorDtaLoading &&
      (
        prevState.cpStatus !== this.state.cpStatus ||
        prevState.cpErrorStatus !== this.state.cpErrorStatus ||
        prevState.carepackErrorDtaLoading !== this.state.carepackErrorDtaLoading ||
        prevState.certObjLoaded !== this.state.certObjLoaded
      )
    ) {
      this.getCAMSErrors();
    }
  }


  handleEmailViewer(uriEnc) {
      if (uriEnc != "") {
          window.open(
              RewriteRESTURL("/os/EmailViewer.tcl?os=" + uriEnc + "&tenant=" + this.props.order.tenant), 
              "downloadwindow", 
              "menubar=1,resizable=1,width=450,height=450"
          )
      }
  }


  getDASDocIds() {
      var self = this;
      GET("/os/ws/fetchDASDocsInfo.tcl?order_no="     + this.props.order.order_no
                                   + "&web_order_no="
                                   + "&tenant="       + this.props.order.tenant
                                   + "&hasPolyItems=true"
          ,{},
          function(res) {
              console.log('iServices:: Results from DAS=', res);
              if (res.status != "E") {
                  self.setState({ 
                      dasStatus: 'S', 
                      dasData: res 
                  });
              }
          }
      );
  }

  getCAMSErrors() {

    var certiNoLen = this.state.carepackDtlData.data.length;
    var carepackErrorDtaNew = _.cloneDeep(this.state.carepackErrorDta);
    var caller = this.props.caller;
    var routeType = "in/widgetExpert";

    if (typeof caller === 'undefined') {
      caller = 'osv';
    } else if ( caller == 'ext_widget') {
      routeType = 'ex/services';
    }

    carepackErrorDtaNew = { header: [
                            { name: DD('item_subitem', caller) },
                            { name: DD('material_no', caller) },
                            { name: DD('certificate_number', caller) },
                            { name: DD('cams_error_open_date', caller) },
                            { name: DD('cams_error_reason_code', caller) },
                            { name: DD('cams_error_reason_descr', caller) },
                          ],
                            data: []
                          }

    var certObk = {};
    for (var i = 0; i < certiNoLen; i++) {

      var item_number         = this.state.carepackDtlData.data[i][0];
      var certificate_number  = this.state.carepackDtlData.data[i][1];
      var product_number      = this.state.carepackDtlData.data[i][2];

      certObk[certificate_number] = {
        item_number     : item_number,
        product_number  : product_number
      }
    }

    this.setState({
      certObjLoaded : true,
      certObjStore  : certObk
    });

    if (this.state.certObjLoaded) {
      for (var i = 0; i < certiNoLen; i++) {
        var certificate_number = this.state.carepackDtlData.data[i][1];
        var system_info = this.state.carepackDtlData.data[i][4];
        console.log("certificate_number=",certificate_number,"system_info=",system_info);

        if (system_info != "EMS") {

          var noErrExistsCounter   = 0;

          var item_number     = this.state.certObjStore[certificate_number].item_number;
          var product_number  = this.state.certObjStore[certificate_number].product_number;

          GET("/os/ossui/v1/" + routeType + "/cams/" + certificate_number + "/" + item_number + "/" + product_number, {}, function(res) {

            if (res.status == 'S') {
              if (res.data.err_exists == false) {
                noErrExistsCounter++
              } else {
                res.data.camsData.forEach(obj => {
                  carepackErrorDtaNew.data.push([
                    obj.itemNumber,
                    obj.productNumber,
                    obj.certNo,
                    fmDate(obj.openDate),
                    obj.reasonCode,
                    obj.reasonDescr,
                  ]);
                });
                this.setState({
                  carepackErrorDta: carepackErrorDtaNew
                });
              }
          } else if (res.status == 'E') {

              carepackErrorDtaNew.data.push([
                "",
                "",
                res.certNo,
                "",
                res.statusCode,
                res.statusMessage
              ]);

              this.setState({
                carepackErrorDta: carepackErrorDtaNew
              });

            }

            if (noErrExistsCounter == certiNoLen) {
              this.setState({
                cpErrorStatus: "N"
              });
            } else if ( i == certiNoLen) {
              this.setState({
                cpErrorStatus: "S"
              });
            } else {
              this.setState({
                cpErrorStatus: "E"
              });
            }

          }.bind(this), this.handleError)

        } // if not EMS

        this.setState({
          carepackErrorDtaLoading: true
        });

      }
    }
  }

  showESDCommitHistModal = e => {
    this.setState({
      showESDCommHist: !this.state.showESDCommHist,
      title: e.currentTarget.textContent,
      pdapi_no_hash: e.currentTarget.value,
    });
  };

  getOtherData(lon) {
    var caller = this.props.caller;

    if (typeof caller === 'undefined') {
      caller = 'osv';
    }

    var rowLimit = "";
    GET("/os/ossui/v1/in/widgetExpert/rmn_licensing/" + lon + "/" + rowLimit, {}, function(res) {
      var otherStatusData = {}

      if (res.status == 'S') {
        otherStatusData =  {
          header: [
            { name: DD('item_subitem', caller) },
            { name: DD('material_no', caller) },
            { name: DD('product_descr', caller), nowrap:1 },
            { name: DD('status', caller) },
            { name: DD('shipped_qty', caller) },
            { name: DD('trackingno', caller) },
            { name: DD('shipment_no', caller) },
            { name: DD('eshp_actual', caller) },
            { name: DD('invoice_no', caller), },
            { name: DD('invo_actual', caller) },
            { name: DD('sched_delv_date', caller) },
            { name: DD('regulatory_model_no', caller) },
            { name: DD('EAC_LIC', caller) },
            { name: DD('ROHS_LIC', caller) },
            { name: DD('CRYPTO_NOT_LIC', caller) },
            { name: DD('CRYPTO_LIC', caller) },
            { name: DD('WIRELESS_LIC', caller) },
            { name: DD('NON_ELC_LIC1', caller) },
            { name: DD('NON_ELC_LIC2', caller) },
            { name: DD('NON_ELC_LIC3', caller) },
            { name: DD('ECCN_LIC', caller) },
          ],
          data: res.data.map(function(row) {

            return [
              row.item_subitem,
              row.material_no,
              row.product_descr,
              row.status,
              row.shipped_qty,
              row.trackingno,
              row.shipment_no,
              fmDateTime(row.eshp_actual),
              row.invoice_no,
              fmDate(row.invo_actual),
              fmDate(row.sched_delv_date),
              row.regulatory_model_no,
              row.eac_lic,
              row.rohs_lic,
              row.crypto_not_lic,
              row.crypto_lic,
              row.wireless_lic,
              row.non_elc_lic1,
              row.non_elc_lic2,
              row.non_elc_lic3,
              row.eccn_lic,
            ]
          }.bind(this))
        }

        this.setState({otherStatusData: otherStatusData})
      }

      this.setState({otherStatus: res.status})

    }.bind(this), this.handleError)
  }

  getESDData(lon) {
    var caller = this.props.caller;

    if (typeof caller === 'undefined') {
      caller = 'osv';
    }

    var rowLimit = "";
    GET("/os/ossui/v1/in/widgetExpert/esdSum/" + lon + "/" + rowLimit, {}, function(res) {
      var esdSumDta = {}

      if (res.status == 'S') {
        esdSumDta =  {
          header: [
            { name: DD('pdapi_no', caller) },
            { name: DD('pdapi_time', caller), nowrap:1 },
            { name: DD('sold_to_email', caller) },
            { name: DD('ship_to_email', caller) },
            { name: DD('bill_to_email', caller) },
            { name: DD('PDAPI Comm Hist', caller) },
          ],
          data: res.data.map(function(row) {

            var commHistLink = (
              <div id="esdCommitHistLink">
                <button type="button" className="btn btn-primary" value={row.pdapi_no_hash} onClick={this.showESDCommitHistModal} >Open Email</button>
              </div>
            )

            return [
              row.pdapi_no,
              row.pdapi_time,
              row.sold_to_email,
              row.ship_to_email,
              row.bill_to_email,
              commHistLink
            ]
          }.bind(this))
        }

        this.setState({esdSumDta: esdSumDta})
      }

      this.setState({esdStatus: res.status})

    }.bind(this), this.handleError)
  }

  getESDDtlData(lon) {
    var caller = this.props.caller;

    if (typeof caller === 'undefined') {
      caller = 'osv';
    }

    var rowLimit = "";
    GET("/os/ossui/v1/in/widgetExpert/esdDtl/" + lon + "/" + rowLimit, {}, function(res) {
      var esdDtlData = {}

      if (res.status == 'S') {
        esdDtlData =  {
          header: [
            { name: DD('item_sln', caller) },
            { name: DD('item_subitem', caller), nowrap:1 },
            { name: DD('material_no', caller) },
            { name: DD('cust_product_no', caller) },
            { name: DD('product_descr', caller) },
            { name: DD('status', caller) },
            { name: DD('ord_qty', caller) },
            { name: DD('pend_qty', caller) },
            { name: DD('delv_qty', caller) },
            { name: DD('cancelled_qty', caller) },
            { name: DD('pdapi_status', caller) },
            { name: DD('pdapi_no', caller) },
          ],
          data: res.data.map(function(row) {
            return [
              row.item_sln,
              row.item_subitem,
              row.material_no,
              row.cust_product_no,
              row.product_descr,
              row.status,
              row.ord_qty,
              row.pend_qty,
              row.delv_qty,
              row.cancelled_qty,
              row.pdapi_status,
              row.pdapi_no,
            ]
          }.bind(this))
        }

        this.setState({esdDtlData: esdDtlData})
      } else if (res.status == 'N') {
        esdDtlData =  {
          header: [
            { name: DD('item_sln', caller) },
            { name: DD('item_subitem', caller), nowrap:1 },
            { name: DD('material_no', caller) },
            { name: DD('cust_product_no', caller) },
            { name: DD('product_descr', caller) },
            { name: DD('status', caller) },
            { name: DD('ord_qty', caller) },
            { name: DD('pend_qty', caller) },
            { name: DD('delv_qty', caller) },
            { name: DD('cancelled_qty', caller) },
            { name: DD('pdapi_status', caller) },
            { name: DD('pdapi_no', caller) },
          ],
          data: []
        }
        this.setState({esdDtlData: esdDtlData})
      }

      this.setState({esdDtlStatus: res.status})

    }.bind(this), this.handleError)
  }

  getCPData(lon) {
    var caller = this.props.caller;
    var routeType = "in/widgetExpert";
    if (typeof caller === 'undefined') {
      caller = 'osv';
    } else if ( caller == 'ext_widget') {
      routeType = 'ex/services';
    }

    var rowLimit = "";
    GET("/os/ossui/v1/" + routeType + "/carepackHdr/" + lon + "/" + rowLimit, {}, function(res) {
      var carepackHdrData = {}

      if (res.status == 'S') {
        carepackHdrData =  {
          header: [
            { name: DD('ref_no', caller) },
            { name: DD('user_id', caller) },
            { name: DD('creation_date', caller) },
            { name: DD('reg_status', caller) },
            { name: DD('edi_assign_to', caller) },
            { name: DD('edi_email', caller) },
            { name: DD('load_timestamp', caller) },
            { name: DD('load_status_id', caller) },
            { name: DD('load_status_desc', caller) },
            { name: DD('load_system_comment', caller) },
          ],
          data: res.data.map(function(row) {

            var ediEmail = row.edi_email;
            var ediEmails = row.edi_email.split(" ");

            if ( ediEmails.length > 1 ) {
                  ediEmail = ediEmails.map((singleEmail) => {
                  return <span>{singleEmail}<br/></span>;
              });
            }


            return [
              row.ref_no,
              row.user_id,
              fmDateTime(row.creation_date),
              row.reg_status,
              row.edi_assign_to,
              ediEmail,
              fmDateTime(row.load_timestamp),
              row.load_status_id,
              row.load_status_desc,
              row.load_system_comment
            ]
          }.bind(this))
        }

        this.setState({carepackHdrData: carepackHdrData})
      }

      this.setState({cpHdrStatus: res.status})

    }.bind(this), this.handleError)
  }

  getCPDtlData(order) {
    var caller = this.props.caller;
    var routeType = "in/widgetExpert";
    if (typeof caller === 'undefined') {
      caller = 'osv';
    } else if ( caller == 'ext_widget') {
      routeType = 'ex/services';
    }

    var rowLimit = "";
    GET("/os/ossui/v1/" + routeType + "/carepackDtl/" + order.legacy_order_no + "/" + rowLimit, {}, function(res) {
      var carepackDtlData = {}

      if (res.status == 'S') {
        carepackDtlData =  {
          header: [
            { name: DD('item_subitem', caller)              },
            { name: DD('certificate_number', caller)        },
            { name: DD('material_no', caller)               }, 
            { name: DD('product_descr', caller)             },
            !["ext_widget"].includes(caller) && { name: DD('care_system_info', caller)          },
            !["ext_widget"].includes(caller) && { name: DD('autoreg_flag', caller)              },
            { name: DD('assign_po', caller)                 },
            { name: DD('assign_to', caller)                 },
            { name: DD('assign_email', caller)              },
            { name: DD('rel_hw_serial_number', caller)      },
            !["ext_widget"].includes(caller) && { name: DD('rel_hw_equi_number', caller) },
            { name: DD('rel_hw_product_number', caller)     },
            { name: DD('rel_hw_poss_prod_number', caller)   },
            { name: DD('rel_hw_purchase_date', caller)      },
            { name: DD('registration_status_code', caller)  },
            { name: DD('registration_date', caller)         },
            { name: DD('cancel_date', caller)               },
            { name: DD('reg_contact_add_no', caller)        },
            { name: DD('service_start_date', caller)        },
            { name: DD('service_end_date', caller)          },
            !["ext_widget"].includes(caller) && { name: DD('service_contract', caller)          },
            !["ext_widget"].includes(caller) && { name: DD('service_contract_item', caller)     },
            !["ext_widget"].includes(caller) && { name: DD('service_contract_stati', caller)    },
            !["ext_widget"].includes(caller) && { name: DD('service_contract_ems_resp', caller) },
            !["ext_widget"].includes(caller) && { name: DD('service_contract_ems_id', caller)   },
            !["ext_widget"].includes(caller) && { name: DD('service_contract_endcust', caller)  },
            !["ext_widget"].includes(caller) && { name: DD('service_contract_reseller', caller) }
          ],
          data: res.data.map(function(row) {
            var regist_status_code = row.registration_status_code;
            var regist_date        = fmDate(row.registration_date);
            var cancel_date = null;
            if (row.inactive == "true") {
                
                cancel_date = <span style={{color: "#c00"}} title={"Reason: "+row.inactive_reason+"\nParty: "+row.cancel_party} >
                                  {fmDate(row.inactive_date)}
                              </span>

            }

            if (row.status === 'CANCELED' && !cancel_date && row.canceled_at) {
                if (row.cancellation_reason) {
                  cancel_date = <span title={"Reason: " + row.cancellation_reason}>{fmDate(row.canceled_at)}</span>
                } else {
                  cancel_date = fmDate(row.canceled_at);
                }
            }

            if (row.inactive == "true") {
                if (row.cancel_party != "") {
                    regist_status_code = <span>{row.registration_status_code}
                                              <span style={{color: "#c00"}}>
                                                    inactive {row.inactive_reason}
                                              </span>
                                        </span>;
                   //                                 <span title="Cancelation Party" style={{color: "#00c"}}>/ {row.cancel_party} </span>
                } else {
                    regist_status_code = <span>{row.registration_status_code}
                                              <span style={{color: "#c00"}}>
                                                    inactive {row.inactive_reason}
                                              </span>
                                        </span>;
                }
                regist_date = <span>{fmDate(row.registration_date)} <span style={{color: "#c00"}}>inactive at {fmDate(row.inactive_date)}</span></span>;
            }

            var regist_contact = row.end_cust_email 
                               + ' ' 
                               + row.end_cust_opsi;

            var cert_no = row.certificate_number;
            console.log("THAR :: cert_number_non_uniq :: ", row.cert_number_non_uniq )  
            if (row.cert_number_non_uniq != null && row.cert_number_non_uniq != '') {
                cert_no = row.cert_number_non_uniq;
                console.log("THAR :: inside :: ", cert_no)
            }   

            var reseller_addr = '';
            var end_cust_addr = '';
            if (!["ext_widget"].includes(caller) && row.reseller_addr_no != '') {
               var addrLines = [];
               addrLines.push(
                   <span><b><a target="_blank" href={"/os/CMaster?bp="+row.reseller_bp_id}>{row.reseller_bp_id}</a></b>:<br/></span>
               );  
               for (var i = 0; i < row.reseller_customer.length; i++) {
                   addrLines.push(
                       <span>{row.reseller_customer[i]}<br/></span>
                   );  
               }
               reseller_addr = <span className="addrPopup">
                                  {row.reseller_customer_name1},
                                  {row.reseller_customer_city}
                                  <span className="addrPopupOverlay">{addrLines}</span>
                               </span>
            } 
            if (!["ext_widget"].includes(caller) && row.end_cust_addr_no != '') {
               var addrLines = [];
               addrLines.push(
                   <span><b><a target="_blank" href={"/os/CMaster?bp="+row.end_cust_bp_id}>{row.end_cust_bp_id}</a></b>:<br/></span>
               );  
               for (var i = 0; i < row.end_customer.length; i++) {
                   addrLines.push(
                       <span>{row.end_customer[i]}<br/></span>
                   );  
               }
               end_cust_addr = <span className="addrPopup">
                                  {row.end_customer_name1},
                                  {row.end_customer_city}
                                  <span className="addrPopupOverlay">{addrLines}</span>
                               </span>
            }

            var rel_hw_product_number = (
                                          <span className="addrPopup">
                                            {row.rel_hw_product_number}
                                            {row.description && (
                                              <span className="addrPopupOverlay">
                                                <span>{row.description}<br/></span>
                                              </span>
                                            )}
                                          </span>
                                        );

            return [
              row.item_subitem,
              cert_no,
              row.material_no,
              row.status === 'CANCELED'
                ? <span field="CANCELED">{row.product_descr}</span>
                : row.product_descr,
              !["ext_widget"].includes(caller) && row.system_info,
              !["ext_widget"].includes(caller) && row.autoreg_flag,
              row.assign_po,
              row.assign_to,
              row.assign_email,
              row.rel_hw_serial_number,
              !["ext_widget"].includes(caller) && row.equipment_number,
              rel_hw_product_number,
              row.rel_hw_poss_prod_number,
              fmDate(row.rel_hw_purchase_date),
              regist_status_code,
              regist_date,
              cancel_date,
              regist_contact,
              fmDate(row.service_start_date),
              fmDate(row.service_end_date),
              !["ext_widget"].includes(caller) && <a href={order.sapuiLinkDisplayServiceContract+"?ServiceContract="+row.service_contract} target="_blank" >{row.service_contract}</a>,
              !["ext_widget"].includes(caller) && row.service_contract_item,
              !["ext_widget"].includes(caller) && row.service_contract_stati,
              !["ext_widget"].includes(caller) && row.ems_response,
              !["ext_widget"].includes(caller) && row.ems_id,
              !["ext_widget"].includes(caller) && end_cust_addr,
              !["ext_widget"].includes(caller) && reseller_addr
            ]
          }.bind(this))
        }
        var cpDtlheader = carepackDtlData.header.filter(item => item !== false);
        var cpDtldata   = carepackDtlData.data.map(innerArray => 
          innerArray.filter(item => item !== false)
        );
        this.setState({carepackDtlData: {header:cpDtlheader, data:cpDtldata}})
      }

      if (res.status == "N") {
        this.setState({ 
          carepackErrorDtaLoading : true,
          cpErrorStatus           : res.status,
          cpStatus                : res.status
        })
      } else {
        this.setState({cpStatus: res.status})
      }

    }.bind(this), this.handleError)
  }

  getCPEmails(lon) {
    var caller = this.props.caller;

    if (typeof caller === 'undefined') {
      caller = 'osv';
    }

    var rowLimit = "";
    GET("/os/ossui/v1/in/widgetExpert/carepackEmail/" + lon + "/" + rowLimit, {}, function(res) {
      var carepackEmailDta = {}

      if (res.status == 'S') {
        carepackEmailDta =  {
          header: [
            { name: DD('email_type', caller) },
            { name: DD('email_to', caller) },
            { name: DD('email_date', caller) },
            { name: DD('initiated_by', caller) },
            { name: DD('email_status', caller) },
          ],
          data: res.data.map(function(row) {
            return [
              row.email_type,
              row.email_to,
              fmDateTime(row.email_date),
              row.ship_to_email,
              row.email_status,
            ]
          }.bind(this))
        }

        this.setState({carepackEmailDta: carepackEmailDta})
      }

      this.setState({cpEmailStatus: res.status})

    }.bind(this), this.handleError)
  }

  getServiceValidation(order) {
    var caller = this.props.caller;

    if (typeof caller === 'undefined') {
      caller = 'osv';
    }

    GET("/os/ws/ServiceValidation.tcl?lno=" + order.legacy_order_no, {}, function(res) {

      var serviceDta = {}

      if (Array.isArray(res)) {
        serviceDta =  {
          header: [
            { name: DD('item_subitem', caller)                     },
            { name: DD('certificate_number', caller)               },
            { name: DD('material_no', caller)                      },
            { name: DD('rel_hw_serial_number', caller)             },
            { name: DD('rel_hw_product_number', caller)            },
            { name: DD('rel_hw_poss_prod_number', caller)          },
            { name: DD('rel_hw_product_line', caller)              },
            { name: DD('rel_hw_equi_number', caller)               },
            { name: DD('warranty_start_date', caller)              },
            { name: DD('warranty_end_date', caller)                },
            { name: DD('prio_service_contract', caller)            },
            { name: DD('prio_service_contract_item', caller)       },
            { name: DD('prio_service_contract_start_date', caller) },
            { name: DD('prio_service_contract_end_date', caller)   },
            { name: DD('prio_service_contract_end_cust', caller)   },
            { name: DD('prio_service_contract_reseller', caller)   },
            { name: DD('prio_service_contract_stati', caller)      }
          ],

          data: res.map(function(row) {

            if (row.warranty_status === 'OUT') {
                row.warranty_end_date = <span className="redbold" style={{ color: "red", fontWeight: "700"}}>{fmDate(row.warranty_end_date)}</span>
                row.warranty_status   = <span style={{ color: "red", fontWeight: "700"}}>{row.warranty_status  }</span>
            } else {
                row.warranty_end_date = fmDate(row.warranty_end_date);
            }

            var cert_no = row.certificate_number;
            if (row.cert_number_non_uniq && row.cert_number_non_uniq != '') {
                cert_no = row.cert_number_non_uniq;
            }

            var reseller_addr = '';
            var end_cust_addr = '';

            if (row.reseller_bp_id != '') {
               var addrLines = [];
               addrLines.push(
                   <span><b><a target="_blank" href={"/os/CMaster?bp="+row.reseller_bp_id}>{row.reseller_bp_id}</a></b>:<br/></span>
               );  
               addrLines.push( <span>{row.reseller_name1}   <br/></span>  );  
               addrLines.push( <span>{row.reseller_name2}   <br/></span>  );  
               addrLines.push( <span>{row.reseller_street}  <br/></span>  );  
               addrLines.push( <span>{row.reseller_postal_code} {row.reseller_city}<br/></span> );  
               addrLines.push( <span>{row.reseller_city}    <br/></span>  );  
               addrLines.push( <span>{row.reseller_country} <br/></span>  );  
      
               reseller_addr = <span className="addrPopup">
                                  {row.reseller_name1},
                                  {row.reseller_city}
                                  <span className="addrPopupOverlay">{addrLines}</span>
                               </span>
            } 
            if (row.end_cust_bp_id != '') {
               var addrLines = [];
               addrLines.push(
                   <span><b><a target="_blank" href={"/os/CMaster?bp="+row.end_cust_bp_id}>{row.end_cust_bp_id}</a></b>:<br/></span>
               );  
               addrLines.push( <span>{row.end_cust_name1}   <br/></span>   );  
               addrLines.push( <span>{row.end_cust_name2}   <br/></span>  );  
               addrLines.push( <span>{row.end_cust_street}  <br/></span>  );  
               addrLines.push( <span>{row.end_cust_postal_code} {row.end_cust_city}<br/></span> );  
               addrLines.push( <span>{row.end_cust_city}    <br/></span>  );  
               addrLines.push( <span>{row.end_cust_country} <br/></span>  );  
      
               end_cust_addr = <span className="addrPopup">
                                  {row.end_cust_name1},
                                  {row.end_cust_city}
                                  <span className="addrPopupOverlay">{addrLines}</span>
                               </span>
            }


            return [
              row.item_subitem,
              cert_no,
              row.product_no,
              row.rel_hw_serial_number,
              row.rel_hw_product_number,
              row.rel_hw_poss_prod_number,
              row.rel_hw_product_no_pl,
              row.equipment_number,
              fmDate(row.warranty_start_date),
              row.warranty_end_date,
              <a href={order.sapuiLinkDisplayServiceContract+"?ServiceContract="+row.prior_service_contract} target="_blank" className="" title=""
              >{row.prior_service_contract}</a>,
              row.prior_service_contract_item,
              fmDate(row.prior_service_start_date),
              fmDate(row.prior_service_end_date),
              end_cust_addr,
              reseller_addr,
              row.stati
            ]
          }.bind(this))
        }

        this.setState({ 
            serviceStatus: 'S', 
            serviceDta:    serviceDta
        });

      } else {
        this.setState({
            serviceStatus: 'E',
        });
      }

    }.bind(this), this.handleError)
  }


  getCPComm(lon) {
    var caller = this.props.caller;

    if (typeof caller === 'undefined') {
      caller = 'osv';
    }

    var rowLimit = "";
    GET("/os/ossui/v1/in/widgetExpert/carepackComm/" + lon + "/" + rowLimit, {}, function(res) {
      var carepackCommDta = {}

      if (res.status == 'S') {
        carepackCommDta =  {
          header: [
            { name: DD('activity_id', caller) },
            { name: DD('activity', caller) },
            { name: DD('system_name', caller) },
            { name: DD('transaction_meaning', caller) },
            { name: DD('msg_time', caller) },
            { name: DD('SAPOrderNo', caller) },
            { name: DD('tracking_comment', caller) },
            { name: DD('setup_id', caller) },
          ],
          data: res.data.map(function(row) {
            return [
              row.activity_id,
              row.activity,
              row.system_name,
              row.transaction_meaning,
              row.msg_time,
              row.order_no,
              row.tracking_comment,
              row.setup_id,
            ]
          }.bind(this))
        }

        this.setState({carepackCommDta: carepackCommDta})
      }

      this.setState({cpCommStatus: res.status})

    }.bind(this), this.handleError)
  }

  getLpdData(lon) {
    var caller = this.props.caller;

    if (typeof caller === 'undefined') {
      caller = 'osv';
    }
    
    var rowLimit = "";
    GET("/os/ossui/v1/in/widgetExpert/iManufacturing/" + lon + "/" + rowLimit, {}, function(res) {
      var lpdData = {}
      var lpdDataDtl = {}

      if (res.status == 'S') {
        lpdData =  {
          header: [
            { name: DD('item_subitem', caller), nowrap:1 },
            { name: DD('material_no', caller) },
            { name: DD('product_descr', caller) },
          ],
          data: res.data.map(function(row) {
            let lpdStatus = this.findInSystemInfo('LPDStatus', row.system_info)
            if (lpdStatus !== '') {
              return [
                row.item_subitem,
                row.material_no,
                row.product_descr,
              ]
          } else {
            return "nonLPD"
          }
          }.bind(this))
        }

        lpdDataDtl =  {
          header: [
            { name: DD('shipment_no', caller) },
            { name: DD('serial_number', caller) },
            { name: DD('system_info', caller) },
            { name: DD('item_subitem', caller), nowrap:1 },
          ],
          data: res.data.map(function(row) {
            let lpdStatus = this.findInSystemInfo('LPDStatus', row.system_info)
            if (lpdStatus !== '') {
              return [
                row.shipment_no,
                row.serial_number,
                lpdStatus,
                row.item_subitem,
              ]
          } else {
            return "nonLPD"
          }

          }.bind(this))
        }


        lpdData.data = lpdData.data.filter(function(x) {
           return x !== "nonLPD";
        });

        lpdDataDtl.data = lpdDataDtl.data.filter(function(x) {
          return x !== "nonLPD";
        });
               

        this.setState({
          lpdData: lpdData,
          lpdDataDtl: lpdDataDtl
        })
      }

      if (this.state.lpdData.data && this.state.lpdData.data.length == 0) {
        res.status = 'N';
      }
      this.setState({lpdStatus: res.status})

    }.bind(this), this.handleError)
  }

  getGemstoneData(lon) {
    var rowLimit = "";
    GET("/os/ossui/v1/in/widgetExpert/iDeviceStatus/" + lon + "/" + rowLimit, {}, function(res) {


      console.log(res);

      if (res.status == 'S') {
        this.setState({
          gemstoneData: res.data
        })
      }

      if (this.state.gemstoneData.data && this.state.gemstonmData.data.length == 0) {
        res.status = 'N';
      }
      this.setState({ 
          gemstoneStatus: res.status
      })

    }.bind(this), this.handleError)
  }


  findInSystemInfo(key, systemInfo) {
    var systemInfoArr = TclListParser.Tcl2Array(systemInfo)

    for (var i = 0; i < systemInfoArr.length; i = i+2)
      if (systemInfoArr[i] == key)
        return systemInfoArr[i+1]

    return ''
  }

  render() {

    var order = this.props.order;
    var caller = this.props.caller;
    const hideTabs = caller === 'ext_widget';

    if (typeof caller === 'undefined') {
      caller = 'osv';
    }

    var ZLPDErrors = [];
    for (var i = 0; i < order.comments.length; i++) {
      if (order.comments[i].key == 'ZLPD' ) {
        ZLPDErrors.push([order.comments[i].key, order.comments[i].value]);
      }
    }

    var entitlementEmails = null;

    if (this.state.hasPolyItems) {


        var dasRows =  null;
        if (this.state.dasStatus == 'S') {
   
            var self = this;    
            var dasRows = this.state.dasData.data.map( function( dasRecord ) {
                var uriEnc = secureValue.Set(dasRecord.uri);
                return [
                    <a onClick={() => self.handleEmailViewer(uriEnc)} target="_blank">
                    <i className="glyphicon glyphicon-circle-arrow-down"></i>
                    &nbsp;
                    {dasRecord.subject}
                    </a>,
                    dasRecord.receiver,
                    dasRecord.sent_date,
                    dasRecord.asset
                ]
            });
        }

        entitlementEmails = 
            <div style={{ marginTop: '6px', backgroundColor: '#ffffff', padding: '10px'}}>
                Entitlement Emails:
                <br/>
                { (this.state.dasStatus == 'S')
                  ? <SimpleDataGrid
                      leftLabel="Entitlement emails"
                      height={ 100 }
                      header={[ 
                          { name: DD('entitlement_email_subject', caller) },
                          { name: DD('entitlement_email_to', caller)      },
                          { name: DD('entitlement_email_date', caller)    },
                          { name: DD('entitlement_email_source', caller)  }
                      ]}
                      data={dasRows}                    
                     />
                  : <BasicAlert type={this.state.dasStatus} />
                }
            </div> 
    }

    var gemstoneHeaders = [
        { name: DD('serial_number', caller)     },
        { name: DD('redemption_code', caller)   },
        { name: DD('lpd_creation_date', caller) },
        { name: DD('registration_date', caller) },
        { name: DD('download_type', caller)     },
        { name: DD('download_date', caller)     },
        { name: DD('endcust_emails', caller)    }
    ]

    var gemstoneRows = [];
    if (this.state.gemstoneStatus === 'S') {
        gemstoneRows = this.state.gemstoneData.map( function( record) {
            return [
                record.serial_number,
                record.redemption_code ,
                fmDateTime( record.creation_date     ),
                fmDateTime( record.registration_date ),
                record.download_type ,
                fmDateTime( record.download_date    ),
                record.endcust_emails
            ]
        });
    }

    return (
      <div className="services" style={{ backgroundColor: '#f4f4f4', padding: '12px', minHeight: '200px' }}>


        {hideTabs && (
          <>
            <div className="carepackDetails">
              <header className="section-header">
                <h3>{T('Certificate Numbers')}</h3>
              </header>
              {this.state.cpStatus === 'S' ?
                <SimpleDataGrid id="carepack_dtl"
                  enableDownload={true}
                  leftLabel={this.state.carepackDtlData.data.length + " items"}
                  sortable={true}
                  height="70px" 
                  header={this.state.carepackDtlData.header}
                  data={this.state.carepackDtlData.data}
                />
                : <BasicAlert type={this.state.cpStatus} />
              }  
            </div>
            { !this.state.hasPolyItems && (
              <div className="carepackErrors">
                <header className="section-header">
                  <h3>{T('Error Handling')}</h3>
                </header>
                {this.state.cpErrorStatus === 'S' ?
                  <SimpleDataGrid id="carepackErrors"
                    enableDownload={false}
                    leftLabel={this.state.carepackErrorDta.data + " items"}
                    sortable={true}
                    height="200px" 
                    header={this.state.carepackErrorDta.header}
                    data={this.state.carepackErrorDta.data}
                  />
                  : <BasicAlert type={this.state.cpErrorStatus} />
                }
              </div>
            )}
          </>
        )}

        {!hideTabs && (
        <>
          <TabBar id="servicesSubTabs">

            <Tab name="carepacksTab" label={T('Carepacks')} activeTab="carepacksTab">
              <div className="carepackDetails">
                <header className="section-header">
                  <h3>{T('Certificate Numbers')}</h3>
                </header>
                {this.state.cpStatus === 'S' ?
                  <SimpleDataGrid id="carepack_dtl"
                    enableDownload={true}
                    leftLabel={this.state.carepackDtlData.data.length + " items"}
                    sortable={true}
                    height="70px" 
                    header={this.state.carepackDtlData.header}
                    data={this.state.carepackDtlData.data}
                  />
                  : <BasicAlert type={this.state.cpStatus} />
                }  
              </div>
              <div className="serviceDetails">
                <header className="section-header">
                  <h3>{T('Service Validation')}</h3>
                </header>
                {this.state.serviceStatus === 'S' ?
                  <SimpleDataGrid id="validation"
                    enableDownload={true}
                    leftLabel={this.state.serviceDta.data.length + " items"}
                    sortable={true}
                    height="70px"
                    header={this.state.serviceDta.header}
                    data={this.state.serviceDta.data}
                  />
                  : <BasicAlert type={this.state.serviceStatus} />
                }
              </div>
              <div className="carepackComm">
                <header className="section-header">
                  <h3>{T('Communication')}</h3>
                </header>
                {this.state.cpCommStatus === 'S' ?
                  <SimpleDataGrid id="communication"
                    enableDownload={false}
                    leftLabel={this.state.carepackCommDta.data + " items"}
                    sortable={true}
                    height="70px" 
                    header={this.state.carepackCommDta.header}
                    data={this.state.carepackCommDta.data}
                  />
                  : <BasicAlert type={this.state.cpCommStatus} />
                }  
              </div>
              <div className="carepackEmail">
                <header className="section-header">
                  <h3>{T('Email Tracking')}</h3>
                </header>
                {this.state.cpEmailStatus === 'S' ?
                  <SimpleDataGrid id="carepackEmails"
                    enableDownload={false}
                    leftLabel={this.state.carepackEmailDta.data + " items"}
                    sortable={true}
                    height="70px" 
                    header={this.state.carepackEmailDta.header}
                    data={this.state.carepackEmailDta.data}
                  />
                  : <BasicAlert type={this.state.cpEmailStatus} />
                }  
              </div>
              <div className="carepackHeader">
                <header className="section-header">
                  <h3>{T('Order Header')}</h3>
                </header>
                {this.state.cpHdrStatus === 'S' ?
                  <SimpleDataGrid id="carepack_hdr"
                    enableDownload={false}
                    leftLabel={this.state.carepackHdrData.data + " items"}
                    sortable={true}
                    height="70px"
                    header={this.state.carepackHdrData.header}
                    data={this.state.carepackHdrData.data}
                  />
                  : <BasicAlert type={this.state.cpHdrStatus} />
                }
              </div>
              <div className="carepackErrors">
                <header className="section-header">
                  <h3>{T('Error Handling')}</h3>
                </header>
                {this.state.cpErrorStatus === 'S' ?
                  <SimpleDataGrid id="carepackErrors"
                    enableDownload={false}
                    leftLabel={this.state.carepackErrorDta.data + " items"}
                    sortable={true}
                    height="200px" 
                    header={this.state.carepackErrorDta.header}
                    data={this.state.carepackErrorDta.data}
                  />
                  : <BasicAlert type={this.state.cpErrorStatus} />
                }
              </div>
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
            </Tab>

            <Tab name="esdTab" label={T('Software')}>
              <div className="esdDetails">

                { entitlementEmails } 

                <div style={{ marginTop: '6px', backgroundColor: '#ffffff', padding: '10px'}}>

                    ESD Emails:

                    { this.state.esdStatus === 'S' && (this.state.esdDtlStatus === 'S' || this.state.esdDtlStatus === 'N')
                      ? <>
                          <ESDCommHistModal pdapiHash={this.state.pdapi_no_hash} onClose={this.showESDCommitHistModal} show={this.state.showESDCommHist}/>
                          <NestedDataGridWrapper
                            id="esd"
                            enableDownload={false}
                            downloadName={'ESD'}
                            dataSum={this.state.esdSumDta}
                            dataDtl={this.state.esdDtlData}
                          />
                        </>
                      : <BasicAlert type={this.state.esdStatus} />
                    }
                </div>  
              
              </div>
            </Tab>

            <Tab name="lpdTab" label={T('Speed Licenses')}>
              <div className="lpdDetails">
                {/*SANDY_GetESDTabSummary */}
                {/*ONLY LPD ITEMS */}
                <LabelGrid data={ZLPDErrors} />
                {this.state.lpdStatus === 'S' ?
                  <NestedDataGridWrapper
                    id="lpd"
                    enableDownload={false}
                    //leftLabel={esdData.data.length + " items"}
                    downloadName={'LPD'}
                    //header={esdData.header}
                    dataSum={this.state.lpdData}
                    dataDtl={this.state.lpdDataDtl}
                  />
                  : this.state.gemstoneStatus === 'S'
                    ? ""
                    : <BasicAlert type={this.state.lpdStatus} />
                }
    
                {this.state.gemstoneStatus === 'S' ?
                  <SimpleDataGrid
                    enableDownload={true}
                    header={gemstoneHeaders}
                    data={gemstoneRows}
                    height="400px"
                  />
                  : this.state.lpdStatus === 'S'
                    ? "" 
                    : <BasicAlert type={this.state.gemstoneStatus} />
                }
    
              </div>
            </Tab>

            <Tab name="otherTab" label={T('Other')}>
              <div className="otherDetails">
                {/*<SimpleTable loadingStatus={this.state.esdStatus} tabData={this.state.esdSumDta} /> */}
                {this.state.otherStatus === 'S' ?
                <>
                  <SimpleDataGrid
                    enableDownload={true}
                    header={this.state.otherStatusData.header}
                    data={this.state.otherStatusData.data}
                    height="400px" stretchTo="#globalFooter" stretchMargin="10"
                  />
                </>
                  : <BasicAlert type={this.state.otherStatus} />
                }
              </div>
            </Tab>

          </TabBar>
        </>
        )}

      </div>
    )
  }

}
